export default __webpack_public_path__ + "static/watts-hughes-spread-1c95d8c29f449ec8b1b7b5182a29dfb9.jpg";